import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60169dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stationDetail" }
const _hoisted_2 = { class: "rg space" }
const _hoisted_3 = { class: "rg space" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_station_detail_component = _resolveComponent("station-detail-component")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_station_data_component = _resolveComponent("station-data-component")!
  const _component_NoDataComponent = _resolveComponent("NoDataComponent")!
  const _component_station_chart_new_component = _resolveComponent("station-chart-new-component")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "detail-header" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_page_header, {
          content: _ctx.station.name,
          title: "",
          onBack: _ctx.goBack
        }, null, 8, ["content", "onBack"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 2,
      class: "detatil-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          lg: 7,
          class: "data-col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_station_detail_component, {
                onParameterClick: _ctx.changeParameter,
                station: _ctx.station_id,
                parameter: _ctx.parameter,
                measurement: _ctx.measurement
              }, null, 8, ["onParameterClick", "station", "parameter", "measurement"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          lg: 17,
          class: "image-col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_station_data_component, {
                date: _ctx.dateFormat(`${this.date}`, `${this.time}`),
                lastImage: _ctx.station.lastImage || {},
                station: _ctx.station_id,
                onParameterClick: _ctx.changeParameter
              }, null, 8, ["date", "lastImage", "station", "onParameterClick"]),
              (_ctx.measurement === '' || (_ctx.type == 'operational' && _ctx.notGraphable(_ctx.measurement)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_NoDataComponent, {
                      message: 
                _ctx.measurement === ''
                  ? 'Seleccione un parámetro para graficar'
                  : 'Este parámetro no es graficable'
              
                    }, null, 8, ["message"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_station_chart_new_component, {
                      station: _ctx.station,
                      parameter: _ctx.parameter
                    }, null, 8, ["station", "parameter"])
                  ]))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}